<template>
<div class="chapter">
<div class="inner_page">
<p class="head">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Hundreds of folks have contributed to this work. From my earliest days in Bristol, I began to hear stories of strange and unexplained happenings. And this continued on through the years and has greatly increased during the past decade or so. I owe a big debt to those people who told me those stories through the years. They have supplied the material that you will read here. They have, indeed, made possible this book.</p>
<p class="indent">Then there is the mechanical need. Publishers now require a work to be computerized, an art that I have not yet learned. Therefore, I must rely on others. Casey Wilson did the early work of this sort for me. She also gave me much encouragement to begin. Then came Bob White, who brought the manuscript to completion with his computer skills. My greatest outlet for historical writings now is a weekly column in the <i>Bristol Herald Courier</i>. I write them all by hand. Then Bob does the computer work, and I am everlastingly grateful for his help. It is also a great benefit to those who regularly read my column.</p>
<p class="indent">Then there are numerous people who have and continue to encourage me to keep on writing. To them, and to all others who have helped in any way, I here express my sincere and grateful appreciation.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?4eec69ae